import useRequest from "./useRequest";
import { useState } from "react";

const useHotels = () => {
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState({
    get: false,
    post: false,
    put: false,
    delete: false,
  });

  const { request } = useRequest();

  async function getHotels(params = {}) {
    return await request(
      "GET",
      "hotels/",
      (data) => {
        setHotels(data);
        return data;
      },
      (error) => {
        return error;
      },
      {},
      params
    );
  }

  async function createHotel(body) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      "hotels/",
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        return error;
      },
      body
    );
    return data;
  }

  async function updateHotel(body) {
    setLoading((prev) => ({ ...prev, put: true }));
    const data = await request(
      "POST",
      `hotels/${body.id}`,
      (data) => {
        setLoading((prev) => ({ ...prev, put: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, put: false }));
        return error;
      },
      body
    );
    return data;
  }

  return { getHotels, hotels, setHotels, createHotel, updateHotel, loading };
};

export default useHotels;
